import axios from 'axios';
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}`;
axios.defaults.withCredentials = true;

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = getCookie('csrftoken');
    if (token) {
      config.headers['X-CSRFToken'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ----------------------------------
// Product APIs
// ----------------------------------
export const getProducts = () => api.get('/api/listview/');

export async function getItenary(productId) {
  try {
    const res = await api.get(`/api/productitenary/${productId}/`); 
    return res.data || {};  
  } catch (error) {
    console.error("Error fetching product:", error);
    return {};  
  }
}


// ----------------------------------
// STATS
// ----------------------------------

export const recordView = (id) =>
  api.post(`/api/count/${id}/view/`);

export const recordClick = (id) =>
  api.post(`/api/count/${id}/click/`);

export const recordFavorite = (id) =>
  api.post(`/api/count/${id}/favorite/`);




// ----------------------------------
// Cart APIs
// ----------------------------------
export const getCart = () => api.get('/api/cart/');

export async function addToCart(productId) {
  const data = {
    product_id: productId, 
  };
  const response = await api.post('/api/cart-items/', data);
  return response.data;
}

export const removeCartItem = (id) =>
  api.delete(`/api/cart-items/${id}/`);

// ----------------------------------
// Orders & Payments
// ----------------------------------
export const getOrders = () => api.get('/api/orders/');
export const getOpenOrders = () => api.get('/api/orders-open/');
export const getCanceledOrders = () => api.get('/api/orders-canceled/');
export const getClosedOrders = () => api.get('/api/orders-closed/');
export const getOrderInstance = (OrderId) => api.get(`/api/orders/${OrderId}/`);
export const deleteOrderInstance = (OrderId) => api.delete(`/api/order/${OrderId}/delete/`);
export const updateOrder = (orderDeliveryId, UpdatePayload) => api.patch(`/api/order/${orderDeliveryId}/update/`, UpdatePayload);


// ----------------------------------
// Bids
// ----------------------------------
export async function getBids(productId) {
  const res = await api.get(`api/products/${productId}/bids/`);
  return Array.isArray(res.data) ? res.data : res.data.results || [];
}

export async function placeBid(productId, bidAmount) {
  const res = await api.post(`api/products/${productId}/bids/`, {
    bid_amount: bidAmount,
  });
  return Array.isArray(res.data) ? res.data : res.data.results || [];
}

export async function deleteBid(bidId) {
  const res = await api.delete(`api/bidlist/delete/${bidId}/`);
  return Array.isArray(res.data) ? res.data : res.data.results || [];
}

export async function fetchSellerBids() {
  const res = await api.get(`api/seller/products/`);
  return Array.isArray(res.data) ? res.data : res.data.results || [];
}
export async function fetchBidderBids() {
  const res = await api.get(`api/bidder/products/`);
  return Array.isArray(res.data) ? res.data : res.data.results || [];
}








